module.exports = __webpack_public_path__ + "img/big3-11.65991840.jpg";